var _defs, _g, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarAcademySeneca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d9faff;\n      }\n\n      .cls-2 {\n        fill: #1c1a18;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #b1e1e5;\n      }\n\n      .cls-5 {\n        fill: #ff4800;\n      }\n\n      .cls-6 {\n        fill: aqua;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "192.48 191.6 106.58 191.6 40.95 210.35 32.43 299.8 266.62 299.8 258.11 210.35 192.48 191.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "40.95 210.35 32.43 299.8 46.07 299.8 49.07 225.73 40.95 210.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "259.05 210.55 267.57 300 253.93 300 250.93 225.93 259.05 210.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "160.07 290 150.23 295 140.07 290 100.07 191 200.07 191 160.07 290"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "161.63 237.91 149.8 241.45 137.98 237.91 115.16 203.85 50.11 165.41 107.27 131.61 184.56 131.61 249.5 165.41 184.44 203.85 161.63 237.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "232.34 40.67 228.12 33.07 169.19 69.65 131.2 69.65 72.07 33.29 67.85 40.9 74.06 100.09 50.53 163.49 106.98 159.83 129.71 162.03 140.18 214.79 160.21 214.79 170.52 162.03 192.71 159.83 249.86 163.49 226.69 100.04 232.34 40.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "192.25 161.75 170.08 163.72 174.03 145.01 208.95 140.84 192.25 161.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "150.23 223.48 140.27 214.52 150.23 211.32 160.19 214.52 150.23 223.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "108.01 161.97 130.18 163.94 126.24 145.22 93.85 141.05 108.01 161.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "67.85 42.9 73.72 101.23 94.89 83.45 67.85 42.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "232.34 42.67 226.47 101.01 205.31 83.23 232.34 42.67"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "160.07 117 149.53 127 140.07 117 136.07 68 164.07 68 160.07 117"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "56.07 159.78 34.07 149.78 34.07 108.78 56.07 98.78 56.07 159.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "49.07 168.67 41.07 68.64 73.07 78.64 78.07 188.67 49.07 168.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "243.07 159.78 265.07 149.78 265.07 108.78 243.07 98.78 243.07 159.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "221.07 188.67 226.07 78.64 258.07 68.64 250.07 168.67 221.07 188.67"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "179.84 80.59 150.23 110.59 121.84 80.59 111.84 57.59 150.23 47.59 189.84 57.59 179.84 80.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAcademySeneca);
export default __webpack_public_path__ + "static/media/avatar-academy-seneca.e88cfae06360f88ffb23d2bc68fe7e2b.svg";
export { ForwardRef as ReactComponent };